export const OrderDirectionEnum = Object.freeze({
    ASC: 'ASCENDING',
    DESC: 'DESCENDING',
  })
  